define('Pusher.Clean', [
    'jQuery'
],
function PusherClean(
    jQuery
) {
    'use strict';

    /**
     * Only Mobile version
     * If you visited a PDP page, opened a pusher (description, etc.), then go back, and then visit another item, the pusher remains opened
     * WSI wanted to remove that behavior
     * This module it is just to delete the memory of a pusher being opened so it doesnt get automatically opened
     */
    return {
        mountToApp: function mountToApp(application) {
            var pdp = application.getComponent('PDP');

            if (pdp) {
                pdp.on('beforeShowContent', function beforeShowContent() {
                    jQuery('[data-pushing]').removeAttr('data-pushing');
                });
            }
        }
    };
});

